import React from 'react'
import { useParams } from 'react-router-dom'
import AIInterviewInstructions from './instruction'

// Dispatcher: works for both
//   (a) inline render from /assessment via Take Assessment (assessment prop provided)
//   (b) standalone route /ai-interview/:assignedId (useParams)
const AIInterview = ({ assignedId: assignedIdProp, assessment, setAssessment }) => {
  const params = useParams()
  const assignedId = assignedIdProp || assessment?.assessment_assigned_id || params?.assignedId

  const effectiveAssessment = assessment || {
    assessment_assigned_id: assignedId,
    type: 'AI_Interview',
    title: 'AI Interview',
  }

  // Inline (portal) launch passes a real setAssessment that returns to the
  // list. The standalone /ai-interview/:id route has none — and using
  // `navigate('/assessment')` as the fallback is a footgun: the instruction
  // screen's mount-time config-fetch effect calls
  //   setAssessment((a) => (a ? { ...a, candidateName } : a))
  // (an updater) AND also `setAssessment(null)`. The previous fallback was a
  // parameterless arrow, so both calls (including the updater) executed
  // `navigate('/assessment')` → fell through to `AuthPage` →
  // `window.open(AUTH_URL, '_self')` (the portal login the candidate was
  // seeing). Use a no-op for the standalone path; the "back" affordance is
  // a close-window/close-tab hint, not a portal page.
  const back = setAssessment || (() => {})

  return <AIInterviewInstructions assessment={effectiveAssessment} setAssessment={back} />
}

export default AIInterview
